import ApiService from '@/utils/ApiService'
import Vue from 'vue'
import addParamsToQuery from '@/utils/addParamsToQuery'
// import getId from '@/utils/getIdFromLink'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    created: null,
    totalSums: [],
    items: [],
    view: [],
    totalItems: 0,
    documentTypeOptions: [
      { value: 1, text: 'views.exsbinvoices.form.salesInvoice' },
      { value: 2, text: 'views.exsbinvoices.form.purchaseInvoice' }
    ],
    invoiceStatusOptions: [],
    firmOptions: [],
    batchNumberOptions: [],
    paymentWayOptions: [],
    vatRateOptions: [],
    invoiceTypeOptions: [],
    itemOptions: [],
    measureOptions: [],
    promotionOptions: [],
    invoicesOptions: [],
    priceNetto: 0,
    priceBrutto: 0
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    totalItems: (state) => state.totalItems,
    totalSums: (state) => state.totalSums,
    documentTypeOptions: (state) => state.documentTypeOptions,
    invoiceStatusOptions: state => state.invoiceStatusOptions,
    firmOptions: state => state.firmOptions,
    batchNumberOptions: state => state.batchNumberOptions,
    paymentWayOptions: state => state.paymentWayOptions,
    vatRateOptions: state => state.vatRateOptions,
    invoiceTypeOptions: state => state.invoiceTypeOptions,
    itemOptions: state => state.itemOptions,
    measureOptions: state => state.measureOptions,
    promotionOptions: state => state.promotionOptions,
    invoicesOptions: state => state.invoicesOptions,
    created: (state) => state.created
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setTotalItems (state, totalItems) {
      state.totalItems = totalItems
    },
    setTotalSums (state, totalSums) {
      state.totalSums = totalSums
    },
    setInvoiceStatusOptions (state, payload) {
      state.invoiceStatusOptions = payload
    },
    setFirmOptions (state, payload) {
      state.firmOptions = payload
    },
    setBatchNumberOptions (state, payload) {
      state.batchNumberOptions = payload
    },
    setPaymentWayOptions (state, payload) {
      state.paymentWayOptions = payload
    },
    setVatRateOptions (state, payload) {
      state.vatRateOptions = payload
    },
    setInvoiceTypeOptions (state, payload) {
      state.invoiceTypeOptions = payload
    },
    setItemOptions (state, payload) {
      state.itemOptions = payload
    },
    setMeasureOptions (state, payload) {
      state.measureOptions = payload
    },
    setPromotionsOptions (state, payload) {
      state.promotionOptions = payload
    },
    setInvoicesOptions (state, payload) {
      let array = []
      for (let i in payload) {
        let textData = payload[i].buyerName + ' / '
        if (payload[i].nip) {
          textData += payload[i].nip + ' / '
        }
        textData += payload[i].number + ' (' + Vue.prototype.$lang.t('views.exsbinvoices.show.toPay') + ': ' + payload[i].toPay + ' / ' +
          Vue.prototype.$lang.t('views.exsbinvoices.form.invoiceValue') + ': ' + payload[i].totalValueBrutto + ')'
        array.push({
          value: payload[i]['@id'],
          text: textData,
          type: payload[i].invoiceType.id
        })
      }
      state.invoicesOptions = array
    },
    setCreated (state, created) {
      state.created = created
    }
  },
  actions: {
    async fetchEXSBInvoicesList ({ commit }, params) {
      const response = await new ApiService('e_x_s_b_invoices', params).getResults()
      commit('setInvoicesOptions', await response.items)
    },
    async getItems ({ commit }, page = 'e_x_s_b_invoices', params) {
      commit('toggleLoading')
      const response = await new ApiService(page, params).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('setTotalItems', await response.totalItems)
      commit('toggleLoading')
      page = addParamsToQuery(page, {
        invoiceSumsFilter: 1,
        pagination: false
      })
      const responseSums = await new ApiService(page, params).getResults()
      commit('setTotalSums', await responseSums.items)
    },
    async fetchInvoiceStatusOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_invoice_statuses', params).getResults()
      commit('setInvoiceStatusOptions', await response.items)
    },
    async fetchFirmOptions ({ commit }) {
      let params = {
        pagination: false,
        isCompany: 1
      }
      const response = await new ApiService('user_datas', params).getResults()
      commit('setFirmOptions', await response.items)
    },
    async fetchBatchNumberOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_batch_numbers', params).getResults()
      let items = await response.items
      items = items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name,
          agreementsAllowed: entry.agreementsAllowed,
          documentsAllowed: entry.documentsAllowed,
          numerationType: entry.numerationType
        }
      })
      commit('setBatchNumberOptions', items)
    },
    async fetchPaymentWayOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_payment_ways', params).getResults()
      commit('setPaymentWayOptions', await response.items)
    },
    async fetchVatRateOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_vat_rates', params).getResults()
      commit('setVatRateOptions', await response.items)
    },
    async fetchInvoiceTypeOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_invoice_types', params).getResults()
      let items = await response.items
      items = items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.name
        }
      })
      commit('setInvoiceTypeOptions', await items)
    },
    async fetchItemOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_items', params).getResults()
      commit('setItemOptions', await response.items)
    },
    async fetchMeasureOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_measures', params).getResults()
      commit('setMeasureOptions', await response.items)
    },
    async fetchPromotions ({ commit }, idUserData) {
      let params = {
        pagination: false,
        idUserData: idUserData
      }
      const response = await new ApiService('e_x_s_b_price_user_datas', params).getResults()
      commit('setPromotionsOptions', await response.items)
    },
    async create ({ commit }, data) {
      commit('toggleLoading')
      const response = await new ApiService('e_x_s_b_price_user_datas').post(data)
      if (response.status < 300) commit('setCreated', await response.json())
      else commit('setViolations', response)
      commit('toggleLoading')
    }
  }
}
